import { createReducer, on } from '@ngrx/store';
import * as fromEnvActions from './env.actions';
import { pause, resume } from '~/modules/app/slice';
import { Environment } from '@qvs/core';

export const envFeatureKey = 'env';

export interface State {
  hasError: boolean;
  isLoading: boolean;
  online: boolean;
  backgroundMode: boolean;
  environment: Environment;
}

export const initialState: State = {
  online: true,
  backgroundMode: false,
  hasError: false,
  isLoading: true,
  environment: null
};

export const reducer = createReducer(
  initialState,
  on(fromEnvActions.loadEnvironmentFailure, (state) => ({
    ...state,
    environment: {} as Environment,
    isLoading: false,
    hasError: true
  })),
  on(fromEnvActions.loadEnvironmentSuccess, (state, action) => ({
    ...state,
    environment: action.environment,
    isLoading: false,
    hasError: false
  })),
  on(fromEnvActions.networkConnectionOff, (state) => ({
    ...state,
    online: false
  })),
  on(fromEnvActions.networkConnectionOn, (state) => ({
    ...state,
    online: true
  })),
  on(resume, (state) => ({
    ...state,
    backgroundMode: false
  })),
  on(pause, (state) => ({
    ...state,
    backgroundMode: true
  }))
);
